module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "toolbar",
    attrs: {
      "id": "toolbar"
    }
  }, [_c('div', {
    on: {
      "click": _vm.fn_hideShowToolbar
    }
  }, [_c('svg', {
    staticClass: "bi bi-justify",
    attrs: {
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 16 16",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2 12.5a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvas.showHideToolbar),
      expression: "canvas.showHideToolbar"
    }]
  }, [_c('div', {
    staticClass: "buttons"
  }, _vm._l((_vm.buttons), function(item, index) {
    return _c('F3dButton', {
      key: index,
      attrs: {
        "button": item
      }
    })
  }), 1)])])]), _vm._v(" "), _c('div', [_c('F3dCanvas', {
    attrs: {
      "width": _vm.canvas.width,
      "height": _vm.canvas.height
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f13c006!./~/vue-loader/lib/selector.js?type=template&index=0!./src/F3D.vue
// module id = 27
// module chunks = 0